import { MyDetails } from '@/models/MyPlayerDetails';

export class StorageService {
  updatePlayerDetails(details: MyDetails) {
    localStorage.setItem('playerDetails', JSON.stringify(details));
  }
  getPlayerDetails(): MyDetails | null {
    const storageString = localStorage.getItem('playerDetails');
    return storageString && JSON.parse(storageString);
  }
  getTheme() {
    return localStorage.getItem('theme');
  }
  updateTheme(theme: string | null) {
    if (theme) localStorage.setItem('theme', theme);
    else localStorage.removeItem('theme');
  }
}
